"use client";

import { useEffect, useState } from "react";
import { useRouter, useSearchParams } from "next/navigation";

const MESSAGES: Record<string, { text: string; tone: "ok" | "warn" }> = {
  checkin: { text: "✓ Csekkin sikeres", tone: "ok" },
  leave: { text: "✓ Hazamentél a pályáról", tone: "ok" },
  "venue-added": { text: "✓ Új helyszín hozzáadva — be is csekkeltél!", tone: "ok" },
  saved: { text: "✓ Profil mentve", tone: "ok" },
  INVALID_TOKEN: {
    text: "⚠ A magic-link már fel lett használva — kérj újat",
    tone: "warn",
  },
};

export default function Flash() {
  const router = useRouter();
  const sp = useSearchParams();
  const [visible, setVisible] = useState<{ text: string; tone: "ok" | "warn" } | null>(null);

  useEffect(() => {
    const flash = sp.get("flash");
    const error = sp.get("error");
    const key = flash ?? error;
    if (!key) return;

    const msg = MESSAGES[key];
    if (!msg) return;

    setVisible(msg);

    // Clear querystring without reload
    const url = new URL(window.location.href);
    url.searchParams.delete("flash");
    url.searchParams.delete("error");
    router.replace(url.pathname + (url.search || ""), { scroll: false });

    const t = setTimeout(() => setVisible(null), 3500);
    return () => clearTimeout(t);
  }, [sp, router]);

  if (!visible) return null;

  const bg =
    visible.tone === "ok"
      ? "bg-[var(--color-acid)] text-[var(--color-bg)]"
      : "bg-[var(--color-warn)] text-[var(--color-bg)]";

  return (
    <div
      className={`fixed top-4 left-1/2 -translate-x-1/2 z-50 ${bg} px-5 py-3 font-display font-bold uppercase tracking-wider text-sm shadow-2xl border-2 border-current anim-fade-up`}
      role="status"
      aria-live="polite"
    >
      {visible.text}
    </div>
  );
}
